// TODO: proper i18n
export const WEEKDAYS = [
	{ full: "Monday", short: "Mon", weekend: false },
	{ full: "Tuesday", short: "Tue", weekend: false },
	{ full: "Wednesday", short: "Wed", weekend: false },
	{ full: "Thursday", short: "Thu", weekend: false },
	{ full: "Friday", short: "Fri", weekend: false },
	{ full: "Saturday", short: "Sat", weekend: true },
	{ full: "Sunday", short: "Sun", weekend: true },
] as const;
